import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

interface InvoiceReviewSectionProps {
  pendingReviewCount: number
  onReviewAllPending: () => void | Promise<void>
  selectedInvoicesCount?: number
}

export function InvoiceReviewSection({
  pendingReviewCount,
  onReviewAllPending,
  selectedInvoicesCount = 0
}: InvoiceReviewSectionProps) {
  return (
    <Card className="relative flex min-h-[280px] flex-1 grow items-start justify-end gap-6 rounded-xl border border-neutral-200 bg-white px-0 py-6 shadow-sm">
      <CardContent className="flex flex-col items-start gap-6 px-6 py-0 relative flex-1 self-stretch grow">
        <div className="flex flex-col items-start gap-6 relative flex-1 grow self-stretch">
          <div className="relative flex w-full flex-[0_0_auto] flex-col items-start justify-center gap-1.5 self-stretch">
            <div className="relative flex w-full flex-[0_0_auto] items-center justify-between self-stretch">
              <span className="whitespace-nowrap text-base font-semibold text-neutral-950">
                Review
              </span>
              {pendingReviewCount > 0 && (
                <div className="relative inline-flex flex-[0_0_auto] items-center gap-2">
                  <div className="relative h-2 w-2 rounded-full bg-red-600" />
                  <span className="whitespace-nowrap text-xs font-medium text-red-600">
                    New
                  </span>
                </div>
              )}
            </div>
            <div className="relative flex w-full flex-[0_0_auto] gap-2.5 self-stretch">
              <p className="flex-1 text-sm font-normal leading-6 text-neutral-500">
                Invoices that need to be reviewed by a human
              </p>
            </div>
          </div>
          <div className="relative flex w-full flex-[0_0_auto] flex-col items-start gap-1.5 self-stretch">
            <div className="relative inline-flex flex-[0_0_auto] items-center justify-center gap-2.5">
              <span className="text-3xl font-semibold text-neutral-950">
                {pendingReviewCount}
              </span>
            </div>
          </div>
        </div>
        <div className="flex w-full items-end gap-2 relative flex-[0_0_auto]">
          <Button
            onClick={onReviewAllPending}
            disabled={pendingReviewCount === 0}
            className="h-9 rounded-lg bg-[#0000ff] px-4 py-2 text-sm font-medium leading-5 text-neutral-50 shadow-box-shadow-shadow-xs hover:bg-[#3333ff] disabled:opacity-50"
          >
            {selectedInvoicesCount > 0 ? `Review Selected (${selectedInvoicesCount})` : 'Review All Pending'}
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
